import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ShortTermIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M13 1C14.6543 1 16 2.3457 16 4V6H14V4C14 3.44824 13.5518 3 13 3H11C10.4482 3 10 3.44824 10 4V6H8V4C8 2.3457 9.3457 1 11 1H13Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M8 10.5H10V19.5H8V10.5Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M16 10.5H14V19.5H16V10.5Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 23H18C19.6543 23 21 21.6543 21 20V10C21 8.3457 19.6543 7 18 7H6C4.3457 7 3 8.3457 3 10V20C3 21.6543 4.3457 23 6 23ZM19 10C19 9.44824 18.5518 9 18 9H6C5.44824 9 5 9.44824 5 10V20C5 20.5518 5.44824 21 6 21H18C18.5518 21 19 20.5518 19 20V10Z",
    fill: "currentColor"
  }));
}